import { useEffect } from 'react';
import { useBlocker, type Blocker } from 'react-router-dom';

/**
 * Två spärrar för samma sak, för att det finns två sätt att lämna en sida.
 *
 * `beforeunload` fångar det webbläsaren äger — stäng flik, ladda om, skriv en
 * ny adress. Den kan inte visa vår egen text, och den går inte att undvika.
 *
 * `useBlocker` fångar navigering inne i appen, där `beforeunload` aldrig
 * utlöses. Den är den som spelar roll i praktiken: läraren klickar "Tillbaka"
 * eller på ett annat menyval, och utan spärren är halvtimmens skrivande borta
 * utan en fråga.
 */
export function useUnsavedChanges(dirty: boolean): Blocker {
  useEffect(() => {
    if (!dirty) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Äldre webbläsare kräver att returnValue sätts för att visa dialogen.
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [dirty]);

  return useBlocker(
    ({ currentLocation, nextLocation }) =>
      dirty && currentLocation.pathname !== nextLocation.pathname,
  );
}
